import { build } from './build-info';
import { Environment } from './environment.type';

export const environment: Environment = {
    build,
    stage: 'production',
    LOGIN_URL: 'https://login.bannerflow.com',
    CLIENT_ID: 'D02b8so9RT6Rx2aqpdosWP1ciE6VVEoX',
    API_URLS: []
};
